export const CROP_SIZE = 256;

export function cropExportGeometry(position, scale) {
  if (!position || !Number.isFinite(position.x) || !Number.isFinite(position.y)
    || !Number.isFinite(scale) || scale <= 0 || scale > CROP_SIZE) return null;
  // Preview coordinates stay logical pixels; only the export raster grows.
  // Never enlarge beyond the native detail inside the selected square.
  const outputSize = Math.floor(Math.min(1024, CROP_SIZE / scale));
  const rasterScale = outputSize / CROP_SIZE;
  return {
    outputSize,
    translateX: (CROP_SIZE / 2 + position.x) * rasterScale,
    translateY: (CROP_SIZE / 2 + position.y) * rasterScale,
    drawScale: scale * rasterScale,
  };
}

export function minimumScaleForCircle(imageWidth, imageHeight, cropSize = CROP_SIZE) {
  if (!imageWidth || !imageHeight) return 1;
  return Math.max(cropSize / imageWidth, cropSize / imageHeight);
}

export function clampCropPosition(position, imageWidth, imageHeight, scale, cropSize = CROP_SIZE) {
  const halfCrop = cropSize / 2;
  const horizontalReach = Math.max(0, (imageWidth * scale) / 2 - halfCrop);
  const verticalReach = Math.max(0, (imageHeight * scale) / 2 - halfCrop);
  const x = Math.min(horizontalReach, Math.max(-horizontalReach, position.x));
  const y = Math.min(verticalReach, Math.max(-verticalReach, position.y));
  return {
    x: Object.is(x, -0) ? 0 : x,
    y: Object.is(y, -0) ? 0 : y,
  };
}
